module.exports = __webpack_public_path__ + "static/img/timg.d0ba900.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/timg.gif
// module id = /oGq
// module chunks = 1